import { render } from "./App.vue?vue&type=template&id=9e4f6f78"
const script = {}

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__